import React, { useState } from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import * as XLSX from 'xlsx';
import apiClient from '../api/client';
import { UploadFile } from '@mui/icons-material';

const ExcelImportDialog = ({ open, onClose, endpoint, onSuccess }) => {
  const [file, setFile] = useState(null);
  const [error, setError] = useState('');
  const [importing, setImporting] = useState(false);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setError('');
  };

  const handleImport = async () => {
    if (!file) {
      setError('Выберите файл Excel (.xlsx)');
      return;
    }

    try {
      setImporting(true);

      // Читаем файл через FileReader
      const data = await file.arrayBuffer();
      const workbook = XLSX.read(data, { type: 'array' });
      const worksheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[worksheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: '' });

      // Отправляем на сервер
      await apiClient.post(endpoint, { data: jsonData });

      if (onSuccess) onSuccess();
      onClose();
    } catch (err) {
      console.error('Ошибка импорта Excel:', err);
      setError('Не удалось импортировать данные');
    } finally {
      setImporting(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Импорт из Excel</DialogTitle>
      <DialogContent>
        <Box sx={{ my: 2 }}>
          <Button variant="contained" component="label" startIcon={<UploadFile />}>
            Выбрать файл
            <input type="file" hidden accept=".xlsx,.xls" onChange={handleFileChange} />
          </Button>
          {file && (
            <Typography variant="body2" sx={{ mt: 1 }}>
              Выбран файл: {file.name}
            </Typography>
          )}
          {error && (
            <Typography variant="body2" color="error" sx={{ mt: 1 }}>
              {error}
            </Typography>
          )}
        </Box>
        <Typography variant="body2" color="text.secondary">
          Файл должен содержать заголовки столбцов в первой строке. Данные первого листа будут импортированы.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={importing}>Отмена</Button>
        <Button onClick={handleImport} variant="contained" disabled={importing || !file}>
          Импортировать
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ExcelImportDialog;